<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.initialInspection_PODataMatch"
      >
        <span
          class="col-form-label"
        >Verify Part number, Mfr, and the Qty match the Purchase Orders and the Packing Slip</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.initialInspection_FactoryLabel"
      >
        <span
          class="col-form-label"
        >Verify that there is a factory label; ensure that there is not a factory label</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.initialInspection_LabelLogo"
      >
        <span
          class="col-form-label"
        >Confirm the manufacturers logo is printed on the label; inspect the spelling; the label should not be able to be smudged</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.initialInspection_ConsistentCodes"
      >
        <span
          class="col-form-label"
        >Verify the country of origin, date codes, and lot codes and ensure they are consistent thoughout the packaging</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.initialInspection_DCAgreement"
      >
        <span
          class="col-form-label"
        >Confirm the date code meets any restrictions specified to the purchase agreement</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.initialInspection_PackagingDamage"
      >
        <span
          class="col-form-label"
        >Any signs of damage to the product or packing. If so enter in notes below</span>
      </b-form-radio-group>
      <b-form-group
        class="mt-2"
        description="Note: Refer to IDEA-STD-IOIO-E Section 10.2. I. 4 for additional information on inspecting discreet elements"
      >
        <b-form-textarea class="col-6" v-model="model.initialInspection_DamageNotes"></b-form-textarea>
      </b-form-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaInitial',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        initialInspection_PODataMatch: this.inspectionDetails[FIELDS.INITIAL_INSPECTION__PODATA_MATCH] || '',
        initialInspection_FactoryLabel: this.inspectionDetails[FIELDS.INITIAL_INSPECTION__FACTORY_LABEL] || '',
        initialInspection_LabelLogo: this.inspectionDetails[FIELDS.INITIAL_INSPECTION__LABEL_LOGO] || '',
        initialInspection_ConsistentCodes: this.inspectionDetails[FIELDS.INITIAL_INSPECTION__CONSISTENT_CODES] || '',
        initialInspection_DCAgreement: this.inspectionDetails[FIELDS.INITIAL_INSPECTION__DCAGREEMENT] || '',
        initialInspection_PackagingDamage: this.inspectionDetails[FIELDS.INITIAL_INSPECTION__PACKAGING_DAMAGE] || '',
        initialInspection_DamageNotes: this.inspectionDetails[FIELDS.INITIAL_INSPECTION__DAMAGE_NOTES] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>